export default [
    
    {
        code: 'No',
        name: 'No',
    },
    {
        code: 'ROFO',
        name: 'Yes - ROFO',
    },
    {
        code: 'ROFR',
        name: 'Yes - ROFR',
    },
    {
        code: 'Other',
        name: 'Other',
    },
];